<div class="p-4">
  <div class="tabs-boxed tabs" role="tablist">
    <a
      class="tab"
      role="tab"
      [class]="{ 'tab-active': currentTab === 'desktop' }"
      (click)="switchTab('desktop')"
      ><span class="mx-4">Desktop</span></a
    >
    <a
      class="tab"
      role="tab"
      [class]="{ 'tab-active': currentTab === 'api' }"
      (click)="switchTab('api')"
      ><span class="mx-4">API</span></a
    >
    <a
      class="tab"
      role="tab"
      [class]="{ 'tab-active': currentTab === 'scheduled' }"
      (click)="switchTab('scheduled')"
      ><span class="mx-4">Scheduled</span></a
    >
  </div>

  <div class="my-8">
    <!-- Filters -->
    <div>
      <div class="flex">
        <label class="form-control">
          <div class="label">
            <span class="label-text">Account #</span>
          </div>
          <input
            type="text"
            class="input input-bordered w-36"
            placeholder="Account #"
            (keydown.enter)="searchInvoices(); $event.preventDefault()"
            [ngModel]="accountSearchQuery"
            (ngModelChange)="onAccountSearchChange($event)"
          />
        </label>
        <label class="form-control ml-4">
          <div class="label">
            <span class="label-text">Company Name</span>
          </div>
          <input
            type="text"
            class="input input-bordered"
            placeholder="Company Name"
            (keydown.enter)="searchInvoices(); $event.preventDefault()"
            [ngModel]="companySearchQuery"
            (ngModelChange)="onCompanySearchChange($event)"
          />
        </label>
        @if (currentTab === 'api') {
          <label class="form-control ml-4">
            <div class="label">
              <span class="label-text">Sales rep</span>
            </div>
            <select
              class="select select-bordered"
              [(ngModel)]="apiInvoiceSalesRepFilterId"
              (ngModelChange)="onApiSalesRepFilterChange()"
            >
              <option [ngValue]="null">All sales reps</option>
              @for (rep of salesReps; track rep.id) {
                <option [ngValue]="rep.id">{{ rep.name }}</option>
              }
            </select>
          </label>
          <label class="form-control ml-4">
            <div class="label">
              <span class="label-text">Transaction month</span>
            </div>
            <select
              class="select select-bordered"
              [(ngModel)]="monthFilter"
              (ngModelChange)="onMonthFilterChange()"
            >
              <option value="">All</option>
              @for (opt of monthFilterOptions; track opt.value) {
                <option [value]="opt.value">{{ opt.label }}</option>
              }
            </select>
          </label>
        }
        <div class="ml-4 flex items-end">
          <button
            class="btn btn-primary"
            (click)="searchInvoices()"
            [disabled]="
              fetchingDesktopInvoices ||
              fetchingApiInvoices ||
              fetchingScheduledInvoices
            "
          >
            Search
          </button>
        </div>
        <div class="ml-4 flex items-end">
          <button
            class="btn btn-warning"
            (click)="clearSearch()"
            [disabled]="
              fetchingDesktopInvoices ||
              fetchingApiInvoices ||
              fetchingScheduledInvoices ||
              (!accountSearchQuery &&
                !companySearchQuery &&
                apiInvoiceSalesRepFilterId == null &&
                !monthFilter)
            "
          >
            Clear
          </button>
        </div>
        <!-- @if (currentTab === 'api') {
          <div class="ml-auto flex items-end">
            <div class="join">
              <button
                class="btn btn-primary join-item"
                (click)="downloadReceipts()"
                [disabled]="downloadingReceipts || !downloadMonth"
              >
                @if (downloadingReceipts) {
                  <span class="loading loading-spinner loading-sm"></span>
                }
                Download Invoices - {{ downloadMonthLabel }}
              </button>
              <div class="dropdown dropdown-end">
                <div
                  tabindex="0"
                  role="button"
                  class="btn btn-primary join-item px-2"
                  [class.btn-disabled]="
                    downloadingReceipts || monthFilterOptions.length === 0
                  "
                >
                  <app-chevron-down-icon class="inline-block h-4 w-4" />
                </div>
                <ul
                  tabindex="0"
                  class="menu dropdown-content z-[1] mt-1 max-h-80 w-56 flex-nowrap overflow-y-auto rounded-box border border-solid border-black bg-base-100 p-2 shadow"
                >
                  @for (opt of monthFilterOptions; track opt.value) {
                    <li>
                      <a
                        [class.active]="opt.value === downloadMonth"
                        (click)="selectDownloadMonth(opt.value)"
                      >
                        {{ opt.label }}
                      </a>
                    </li>
                  } @empty {
                    <li class="disabled">
                      <a>No months available</a>
                    </li>
                  }
                </ul>
              </div>
            </div>
          </div>
        } -->
      </div>

      <div class="flex space-x-4 pb-8 pt-4">
        @if (currentTab === 'scheduled') {
          <div class="form-control">
            <label class="label cursor-pointer">
              <span class="label-text pr-2">Pending</span>
              <input
                type="checkbox"
                class="checkbox checkbox-sm"
                [(ngModel)]="scheduledIncludePending"
                (ngModelChange)="onScheduledFiltersChange()"
              />
            </label>
          </div>
          <div class="form-control">
            <label class="label cursor-pointer">
              <span class="label-text pr-2">Failed</span>
              <input
                type="checkbox"
                class="checkbox checkbox-sm"
                [(ngModel)]="scheduledIncludeFailed"
                (ngModelChange)="onScheduledFiltersChange()"
              />
            </label>
          </div>
          <div class="form-control">
            <label class="label cursor-pointer">
              <span class="label-text pr-2">Completed</span>
              <input
                type="checkbox"
                class="checkbox checkbox-sm"
                [(ngModel)]="scheduledIncludeCompleted"
                (ngModelChange)="onScheduledFiltersChange()"
              />
            </label>
          </div>
        } @else {
          <div class="form-control">
            <label class="label cursor-pointer">
              <span class="label-text pr-2">Include Pending</span>
              <input
                type="checkbox"
                class="checkbox checkbox-sm"
                [(ngModel)]="includePending"
                (ngModelChange)="searchInvoices()"
              />
            </label>
          </div>
          <div class="form-control">
            <label class="label cursor-pointer">
              <span class="label-text pr-2">Include Completed</span>
              <input
                type="checkbox"
                class="checkbox checkbox-sm"
                [(ngModel)]="includeComplete"
                (ngModelChange)="searchInvoices()"
              />
            </label>
          </div>
          <div class="form-control">
            <label class="label cursor-pointer">
              <span class="label-text pr-2">Include Expired</span>
              <input
                type="checkbox"
                class="checkbox checkbox-sm"
                [(ngModel)]="includeExpired"
                (ngModelChange)="searchInvoices()"
              />
            </label>
          </div>
        }
      </div>
    </div>

    @if (
      fetchingDesktopInvoices ||
      fetchingApiInvoices ||
      fetchingScheduledInvoices
    ) {
      <div class="ml-8 flex pt-8">
        <div class="loading loading-spinner"></div>
      </div>
    } @else if (desktopInvoices && currentTab === 'desktop') {
      <div
        class="w-full overflow-x-auto rounded-lg border border-base-content/20"
      >
        <!-- Desktop Invoices Table -->
        <table
          class="table table-zebra static"
          [ngClass]="{
            'table-lg': tableSpacing === 'comfortable',
            'table-md': tableSpacing === 'normal',
            'table-sm': tableSpacing === 'compact',
          }"
        >
          <thead class="text-base font-medium">
            <tr>
              <td>Invoice #</td>
              <td>Acct #</td>
              <td>Company</td>
              <td>Status</td>
              <td>Total Amount</td>
              <td>Created Date</td>
              <td>Completed Date</td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            @for (invoice of desktopInvoices; track invoice) {
              <tr
                class="cursor-pointer"
                (click)="
                  browseToInvoice(
                    invoice.desktop_invoice.id,
                    invoice.desktop_invoice.tenant_id,
                    'desktop'
                  )
                "
              >
                <td class="whitespace-nowrap">
                  {{ invoice.desktop_invoice.number }}
                </td>
                <td>
                  {{ invoice.tenant.account_number }}
                </td>
                <td>{{ invoice.tenant.company }}</td>
                <td
                  [ngClass]="{
                    'text-error':
                      invoiceStatus(invoice.desktop_invoice) === 'Expired',
                  }"
                >
                  {{ invoiceStatus(invoice.desktop_invoice) }}
                </td>
                <td>
                  {{ invoice.desktop_invoice.total_amount | currency }}
                </td>
                <td>
                  {{
                    invoice.desktop_invoice.created_at
                      | date: 'MM/dd/yyyy, hh:mmaa'
                  }}
                </td>
                <td>
                  @if (invoice.desktop_invoice.completed) {
                    {{
                      invoice.desktop_invoice.completed_at
                        | date: 'MM/dd/yyyy, hh:mmaa'
                    }}
                  } @else {
                    N/A
                  }
                </td>
                @if (!invoice.desktop_invoice.completed) {
                  <td>
                    <div
                      class="cursor-pointer text-error hover:text-error/80"
                      [ngClass]="{
                        'h-4 w-4': tableSpacing === 'compact',
                        'h-5 w-5': tableSpacing === 'normal',
                        'h-6 w-6': tableSpacing === 'comfortable',
                      }"
                      (click)="
                        promptDeleteDesktopInvoice(
                          $event,
                          invoice.desktop_invoice
                        )
                      "
                    >
                      <app-trash-icon></app-trash-icon>
                    </div>
                  </td>
                } @else {
                  <td></td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>

      <div class="mt-5">
        <app-pagination
          [spacing]="tableSpacing"
          [pageSize]="pageSize"
          [currentPage]="currentPage"
          [totalPages]="totalPages"
          (pageChanged)="changePage($event)"
          (settingsChanged)="handleSettingsChanged($event)"
        ></app-pagination>
      </div>
    } @else if (apiInvoices && currentTab === 'api') {
      @if (errorSettingSelectedApiInvoicesToAutoPay) {
        <p class="mb-4 text-error">
          {{ errorSettingSelectedApiInvoicesToAutoPay }}
        </p>
      }

      <div class="mb-4 flex justify-between space-x-2">
        <div class="flex space-x-2">
          @if (selectedApiInvoiceIds.size === 0) {
            <button
              class="btn btn-secondary btn-sm mr-auto"
              (click)="openAutoProcessAllPendingDialog()"
              [disabled]="fetchingPendingUnqueuedCount"
            >
              Auto process all pending
            </button>
            @if (fetchingPendingUnqueuedCount) {
              <div class="loading loading-spinner loading-sm"></div>
            }
          } @else {
            <button
              class="btn btn-secondary btn-sm"
              (click)="setSelectedApiInvoicesToAutoPay()"
              [disabled]="
                settingSelectedApiInvoicesToAutoPay ||
                selectedApiInvoiceIds.size === 0
              "
            >
              Auto process {{ selectedApiInvoiceIds.size }} selected invoices
            </button>
            @if (settingSelectedApiInvoicesToAutoPay) {
              <div class="loading loading-spinner loading-sm"></div>
            }
          }
        </div>
        <div class="flex space-x-2">
          <button
            class="btn btn-primary btn-sm"
            (click)="openUploadApiInvoicesDialog()"
          >
            Upload New Invoices
          </button>
          <button
            class="btn btn-primary btn-sm"
            (click)="openUploadJobLogsDialog()"
          >
            Upload Job Logs
          </button>
        </div>
      </div>
      <div
        class="flex flex-wrap items-center gap-x-6 gap-y-2 px-4 py-3 text-sm"
      >
        <span class="font-medium text-base-content/70">Sort by</span>
        <button
          type="button"
          class="link-hover link inline-flex items-center gap-1 font-medium"
          (click)="onApiInvoiceSortChange('company_name')"
        >
          Company
          @if (apiInvoiceSortBy === 'company_name') {
            @if (apiInvoiceSortDirection === 'ASC') {
              <app-chevron-up-icon class="inline-block h-4 w-4" />
            } @else {
              <app-chevron-down-icon class="inline-block h-4 w-4" />
            }
          }
        </button>
        <button
          type="button"
          class="link-hover link inline-flex items-center gap-1 font-medium"
          (click)="onApiInvoiceSortChange('account_number')"
        >
          Account
          @if (apiInvoiceSortBy === 'account_number') {
            @if (apiInvoiceSortDirection === 'ASC') {
              <app-chevron-up-icon class="inline-block h-4 w-4" />
            } @else {
              <app-chevron-down-icon class="inline-block h-4 w-4" />
            }
          }
        </button>
      </div>

      <div
        class="w-full overflow-x-auto rounded-lg border border-base-content/20"
      >
        <!-- API Invoices Table -->
        <table
          class="table table-zebra static"
          [ngClass]="{
            'table-lg': tableSpacing === 'comfortable',
            'table-md': tableSpacing === 'normal',
            'table-sm': tableSpacing === 'compact',
          }"
        >
          <thead class="text-base font-medium">
            <tr>
              <td class="w-10"></td>
              <td>Invoice #</td>
              <td>Acct #</td>
              <td>Company</td>
              <td>Sales rep</td>
              <td>Status</td>
              <td>Month</td>
              <td class="w-fit text-right">Total</td>
              <td>Created Date</td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            @for (invoice of apiInvoices; track invoice) {
              <tr
                class="cursor-pointer"
                (click)="
                  browseToInvoice(
                    invoice.api_invoice_details.api_invoice.id,
                    invoice.api_invoice_details.api_invoice.tenant_id,
                    'api'
                  )
                "
              >
                <td (click)="$event.stopPropagation()">
                  @if (
                    invoice.api_invoice_details.api_invoice.completed ||
                    invoice.api_invoice_details.api_invoice.auto_pay_enabled
                  ) {
                    <div class="h-4 w-4"></div>
                  } @else {
                    <input
                      type="checkbox"
                      class="checkbox"
                      [checked]="
                        isApiInvoiceSelected(
                          invoice.api_invoice_details.api_invoice.id
                        )
                      "
                      (click)="$event.stopPropagation()"
                      (change)="
                        toggleApiInvoiceSelection(
                          $event,
                          invoice.api_invoice_details.api_invoice
                        )
                      "
                      [disabled]="
                        settingSelectedApiInvoicesToAutoPay ||
                        invoice.api_invoice_details.api_invoice.auto_pay_enabled
                      "
                    />
                  }
                </td>
                <td class="whitespace-nowrap">
                  {{ invoice.api_invoice_details.api_invoice.number }}
                </td>
                <td>
                  {{ invoice.tenant.account_number }}
                </td>
                <td>{{ invoice.tenant.company }}</td>
                <td>
                  {{ formatSalesReps(invoice.api_invoice_details.sales_reps) }}
                </td>
                <td
                  [ngClass]="{
                    'text-error':
                      invoiceStatus(invoice.api_invoice_details.api_invoice) ===
                      'Expired',
                  }"
                >
                  {{ invoiceStatus(invoice.api_invoice_details.api_invoice) }}
                </td>
                <td class="whitespace-nowrap">
                  {{
                    getDisplayTransactionMonth(
                      invoice.api_invoice_details.api_invoice.transaction_yyyymm
                    ) | date: 'MMM, yyyy'
                  }}
                </td>
                <td class="w-fit text-right">
                  {{
                    invoice.api_invoice_details.api_invoice.total_amount
                      | currency
                  }}
                </td>
                <td>
                  {{
                    invoice.api_invoice_details.api_invoice.created_at
                      | date: 'MM/dd/yyyy, hh:mmaa'
                  }}
                </td>
                @if (!invoice.api_invoice_details.api_invoice.completed) {
                  <td>
                    <div
                      class="cursor-pointer text-error hover:text-error/80"
                      [ngClass]="{
                        'h-4 w-4': tableSpacing === 'compact',
                        'h-5 w-5': tableSpacing === 'normal',
                        'h-6 w-6': tableSpacing === 'comfortable',
                      }"
                      (click)="
                        promptDeleteApiInvoice(
                          $event,
                          invoice.api_invoice_details.api_invoice
                        )
                      "
                    >
                      <app-trash-icon></app-trash-icon>
                    </div>
                  </td>
                } @else {
                  <td></td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>

      <div class="mt-5">
        <app-pagination
          [spacing]="tableSpacing"
          [pageSize]="pageSize"
          [currentPage]="currentPage"
          [totalPages]="totalPages"
          (pageChanged)="changePage($event)"
          (settingsChanged)="handleSettingsChanged($event)"
        ></app-pagination>
      </div>
    } @else if (scheduledInvoices && currentTab === 'scheduled') {
      <div class="w-full space-y-4">
        @for (invoice of scheduledInvoices; track invoice; let i = $index) {
          <!-- Scheduled Invoice Card -->
          <div
            class="card border border-base-content/20"
            [ngClass]="{
              'bg-base-200': i % 2 === 0,
              'bg-base-100': i % 2 === 1,
            }"
          >
            <div class="card-body p-4">
              <div class="absolute right-3 top-2">
                <app-dots-horizontal-icon
                  class="cursor-pointer"
                  (click)="
                    openScheduledInvoiceActionsMenu(
                      $event,
                      invoice.api_invoice_details.api_invoice
                    )
                  "
                ></app-dots-horizontal-icon>
                @if (
                  scheduledInvoiceActionsMenuOpen &&
                  scheduledInvoiceForActionsMenu?.id ===
                    invoice.api_invoice_details.api_invoice.id
                ) {
                  <div
                    class="absolute right-0 rounded-md border border-base-content/20 bg-base-300 p-4 shadow-lg"
                  >
                    <button
                      class="btn btn-primary btn-sm whitespace-nowrap"
                      (click)="
                        disableApiInvoiceAutoPay(
                          invoice.api_invoice_details.api_invoice
                        )
                      "
                      [disabled]="removingFromScheduledInvoices"
                    >
                      Disable auto pay
                    </button>
                    @if (removingFromScheduledInvoices) {
                      <div class="mt-2 flex justify-center">
                        <div class="loading loading-spinner loading-sm"></div>
                      </div>
                    }
                  </div>
                }
              </div>
              <div class="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
                <div>
                  <div class="text-sm font-semibold text-base-content/60">
                    Invoice #
                  </div>
                  <div class="text-base">
                    <span
                      class="text-link"
                      (click)="
                        browseToInvoice(
                          invoice.api_invoice_details.api_invoice.id,
                          invoice.api_invoice_details.api_invoice.tenant_id,
                          'api'
                        )
                      "
                    >
                      {{ invoice.api_invoice_details.api_invoice.number }}
                    </span>
                  </div>
                </div>
                <div>
                  <div class="text-sm font-semibold text-base-content/60">
                    Account #
                  </div>
                  <div class="text-base">
                    {{ invoice.tenant.account_number }}
                  </div>
                </div>
                <div>
                  <div class="text-sm font-semibold text-base-content/60">
                    Company
                  </div>
                  <div class="text-base">{{ invoice.tenant.company }}</div>
                </div>
                <div>
                  <div class="text-sm font-semibold text-base-content/60">
                    Sales rep
                  </div>
                  <div class="text-base">
                    {{
                      formatSalesReps(invoice.api_invoice_details.sales_reps)
                    }}
                  </div>
                </div>
                <div>
                  <div class="text-sm font-semibold text-base-content/60">
                    Status
                  </div>
                  <div
                    class="text-base font-medium"
                    [ngClass]="{
                      'text-warning':
                        scheduledInvoiceStatus(
                          invoice.api_invoice_details.api_invoice
                        ) === 'pending',
                      'text-info':
                        scheduledInvoiceStatus(
                          invoice.api_invoice_details.api_invoice
                        ) === 'processing',
                      'text-error':
                        scheduledInvoiceStatus(
                          invoice.api_invoice_details.api_invoice
                        ) === 'failed',
                      'text-success':
                        scheduledInvoiceStatus(
                          invoice.api_invoice_details.api_invoice
                        ) === 'completed',
                    }"
                  >
                    {{
                      scheduledInvoiceStatus(
                        invoice.api_invoice_details.api_invoice
                      ) || 'N/A' | titlecase
                    }}
                  </div>
                </div>
                <div>
                  <div class="text-sm font-semibold text-base-content/60">
                    Month
                  </div>
                  <div class="text-base">
                    {{
                      getDisplayTransactionMonth(
                        invoice.api_invoice_details.api_invoice
                          .transaction_yyyymm
                      ) | date: 'MMM, yyyy'
                    }}
                  </div>
                </div>
                <div>
                  <div class="text-sm font-semibold text-base-content/60">
                    Total Amount
                  </div>
                  <div class="text-base">
                    {{
                      invoice.api_invoice_details.api_invoice.total_amount
                        | currency
                    }}
                  </div>
                </div>
                <div>
                  <div class="text-sm font-semibold text-base-content/60">
                    @if (
                      invoice.api_invoice_details.api_invoice.auto_pay_queued_at
                    ) {
                      Queued At
                    } @else if (
                      invoice.api_invoice_details.api_invoice
                        .auto_pay_scheduled_at
                    ) {
                      Scheduled For
                    } @else {
                      Scheduled/Queued
                    }
                  </div>
                  <div class="text-base">
                    @if (
                      invoice.api_invoice_details.api_invoice.auto_pay_queued_at
                    ) {
                      {{
                        invoice.api_invoice_details.api_invoice
                          .auto_pay_queued_at | date: 'MM/dd/yyyy, hh:mmaa'
                      }}
                    } @else if (
                      invoice.api_invoice_details.api_invoice
                        .auto_pay_scheduled_at
                    ) {
                      {{
                        invoice.api_invoice_details.api_invoice
                          .auto_pay_scheduled_at | date: 'MM/dd/yyyy, hh:mmaa'
                      }}
                    } @else {
                      -
                    }
                  </div>
                </div>
                <div>
                  <div class="text-sm font-semibold text-base-content/60">
                    Created Date
                  </div>
                  <div class="text-base">
                    {{
                      invoice.api_invoice_details.api_invoice.created_at
                        | date: 'MM/dd/yyyy, hh:mmaa'
                    }}
                  </div>
                </div>
              </div>
              @if (
                !invoice.api_invoice_details.api_invoice.completed &&
                invoice.api_invoice_details.api_invoice.auto_pay_failure_reason
              ) {
                <div class="mt-4 border-t border-base-content/20 pt-4">
                  <div class="text-sm text-error">Failure Reason</div>
                  <div class="mt-1 text-sm text-error">
                    {{
                      invoice.api_invoice_details.api_invoice
                        .auto_pay_failure_reason
                    }}
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <div class="mt-5">
        <app-pagination
          [spacing]="tableSpacing"
          [pageSize]="pageSize"
          [currentPage]="currentPage"
          [totalPages]="totalPages"
          (pageChanged)="changePage($event)"
          (settingsChanged)="handleSettingsChanged($event)"
        ></app-pagination>
      </div>
    }
  </div>
</div>

<dialog class="modal" #deleteDesktopInvoiceDialog>
  <div class="modal-box max-w-3xl p-8">
    <form method="dialog">
      <button class="btn btn-circle btn-ghost btn-sm absolute right-2 top-2">
        ✕
      </button>
    </form>
    @if (fetchingDesktopInvoiceToDelete) {
      <div class="loading loading-spinner"></div>
    } @else if (errorFetchingDesktopInvoiceToDelete) {
      <p class="text-center text-error">
        {{ errorFetchingDesktopInvoiceToDelete }}
      </p>
    } @else if (!desktopInvoiceToDelete) {
      <p class="text-center text-error">No invoice to delete</p>
    } @else {
      <h3 class="text-lg font-bold">Confirm Invoice Deletion</h3>

      <div class="my-4">
        <div>
          <p class="mb-2">
            Invoice #:
            {{ desktopInvoiceToDelete.desktop_invoice.number }}
          </p>
          <p class="mb-2">
            Invoice created on:
            {{
              desktopInvoiceToDelete.desktop_invoice.created_at
                | date: 'MM/dd/yyyy'
            }}
          </p>
          <p class="mb-2">
            Total Amount:
            {{
              desktopInvoiceToDelete.desktop_invoice.total_amount
                | currency: 'USD'
            }}
          </p>
          <p class="mb-4 mt-2">
            Due by:
            {{ desktopInvoiceToDelete.due_by | date: 'MM/dd/yyyy' : 'UTC' }}
          </p>
        </div>
      </div>

      <div class="overflow-x-auto">
        <table class="table table-zebra">
          <thead class="text-sm">
            <tr>
              <th class="font-medium">Product</th>
              <th class="font-medium">Type</th>
              <th class="font-medium">New Expiration</th>
              <th class="text-right font-medium">Price</th>
            </tr>
          </thead>
          <tbody>
            @for (el of desktopInvoiceToDelete.license_details; track el) {
              <tr>
                <td>{{ el.license_with_product.product.title }}</td>
                <td>
                  {{ el.license_with_product.site_license ? 'Site' : 'Main' }}
                </td>
                <td>
                  {{ el.new_expiration_date | date: 'MM/dd/yyyy' : 'UTC' }}
                </td>
                <td class="text-right">
                  {{ el.base_amount | currency: 'USD' }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <p class="mt-8 text-sm text-error">
        This deletion is permanent. Are you sure you want to delete this
        invoice?
      </p>

      <div class="mt-4 flex justify-end">
        @if (deletingDesktopInvoice) {
          <div class="loading loading-spinner mr-4"></div>
        }
        <button
          class="btn btn-primary mr-4"
          (click)="deleteDesktopInvoice(desktopInvoiceToDelete)"
          [disabled]="deletingDesktopInvoice"
        >
          Delete
        </button>
        <button
          class="btn btn-neutral"
          (click)="closeDeleteDesktopInvoiceDialog()"
        >
          Cancel
        </button>
      </div>

      @if (errorDeletingDesktopInvoice) {
        <div class="mt-4">
          <p class="text-center text-error">
            {{ errorDeletingDesktopInvoice }}
          </p>
        </div>
      }
    }
  </div>
</dialog>

<dialog
  class="modal"
  #autoProcessAllPendingDialog
  (close)="closeAutoProcessAllPendingDialog()"
>
  <div class="modal-box max-w-md p-8">
    <form method="dialog">
      <button class="btn btn-circle btn-ghost btn-sm absolute right-2 top-2">
        ✕
      </button>
    </form>
    <h3 class="text-lg font-bold">Auto process all pending</h3>
    @if (fetchingPendingUnqueuedCount) {
      <div class="my-4 flex justify-center">
        <div class="loading loading-spinner loading-md"></div>
      </div>
    } @else {
      <p class="my-4">
        There are currently
        <strong>{{ pendingUnqueuedCount ?? 0 }}</strong>
        pending API invoice(s) not yet in the auto processing queue.
      </p>
      <p class="mb-4 text-sm">
        Add all of them to the queue to be automatically processed?
      </p>
      <div class="flex justify-end gap-2">
        @if (queueingAllPendingApiInvoices) {
          <div class="loading loading-spinner"></div>
        }
        <button
          class="btn btn-primary"
          (click)="confirmAutoProcessAllPending()"
          [disabled]="
            queueingAllPendingApiInvoices || (pendingUnqueuedCount ?? 0) === 0
          "
        >
          Confirm
        </button>
        <button
          class="btn btn-neutral"
          (click)="closeAutoProcessAllPendingDialog()"
          [disabled]="queueingAllPendingApiInvoices"
        >
          Cancel
        </button>
      </div>
      @if (errorQueueingAllPendingApiInvoices) {
        <p class="mt-4 text-sm text-error">
          {{ errorQueueingAllPendingApiInvoices }}
        </p>
      }
    }
  </div>
</dialog>

<dialog class="modal" #deleteApiInvoiceDialog>
  <div class="modal-box max-w-3xl p-8">
    <form method="dialog">
      <button class="btn btn-circle btn-ghost btn-sm absolute right-2 top-2">
        ✕
      </button>
    </form>
    @if (!apiInvoiceToDelete) {
      <p class="text-center text-error">No invoice to delete</p>
    } @else {
      <h3 class="text-lg font-bold">Confirm Invoice Deletion</h3>

      <div class="my-4">
        <div>
          <p class="mb-2">
            Invoice #:
            {{ apiInvoiceToDelete.number }}
          </p>
          <p class="mb-2">
            Invoice created on:
            {{ apiInvoiceToDelete.created_at | date: 'MM/dd/yyyy' : 'UTC' }}
          </p>
          <p class="mb-2">
            Total Amount:
            {{ apiInvoiceToDelete.total_amount | currency: 'USD' }}
          </p>
          <p class="mt-2">Job Count: {{ apiInvoiceToDelete.job_count }}</p>
          <p class="mb-4 mt-2">
            Due by:
            {{ apiInvoiceToDelete.expiration | date: 'MM/dd/yyyy' : 'UTC' }}
          </p>
        </div>
      </div>

      <p class="mt-8 text-sm text-error">
        This deletion is permanent. Are you sure you want to delete this
        invoice?
      </p>

      <div class="mt-4 flex justify-end">
        @if (deletingApiInvoice) {
          <div class="loading loading-spinner mr-4"></div>
        }
        <button
          class="btn btn-primary mr-4"
          (click)="deleteApiInvoice(apiInvoiceToDelete)"
          [disabled]="deletingApiInvoice"
        >
          Delete
        </button>
        <button class="btn btn-neutral" (click)="closeDeleteApiInvoiceDialog()">
          Cancel
        </button>
      </div>

      @if (errorDeletingApiInvoice) {
        <div class="mt-4">
          <p class="text-center text-error">{{ errorDeletingApiInvoice }}</p>
        </div>
      }
    }
  </div>
</dialog>

<dialog class="modal" #uploadApiInvoicesDialog>
  <div class="modal-box max-w-5xl p-8">
    <form method="dialog">
      <button
        class="btn btn-circle btn-ghost btn-sm absolute right-2 top-2"
        (click)="closeUploadApiInvoicesDialog()"
      >
        ✕
      </button>
    </form>

    <h3 class="text-lg font-bold">Upload API Invoices</h3>

    <div class="mt-4 flex justify-between">
      <label class="form-control w-full">
        <div class="label">
          <span class="label-text">Select API Transactions File</span>
        </div>
        <input
          #apiTransactionsFileInput
          type="file"
          class="file-input file-input-bordered w-full"
          (change)="handleApiTransactionsFileChange($event)"
        />
      </label>
    </div>

    <div class="mt-4 flex items-end justify-end">
      @if (validatingApiTransactionsFile) {
        <div class="loading loading-spinner mr-4"></div>
      }
      <button
        class="btn btn-primary"
        (click)="validateApiTransactionsFile()"
        [disabled]="validatingApiTransactionsFile || !apiTransactionsFile"
      >
        Validate File
      </button>
    </div>

    @if (errorValidatingApiTransactionsFile) {
      <p class="mt-4 text-center text-error">
        {{ errorValidatingApiTransactionsFile }}
      </p>
    }

    <ng-template
      #validationResponses
      let-responses="responses"
      let-title="title"
    >
      <div class="card card-bordered card-compact bg-base-100">
        <div class="card-body">
          <p class="card-title">{{ title }}:</p>

          <table class="table table-sm">
            <thead class="text-sm">
              <tr>
                <td>Acct #</td>
                <td>Company</td>
                <td>Sales Rep</td>
                <td>Job Count</td>
                <td>Transaction Month</td>
                <td>Invoice Amount</td>
              </tr>
            </thead>
            <tbody>
              @for (response of responses; let i = $index; track response) {
                <div
                  class="table-row"
                  [ngClass]="{ 'bg-base-200': i % 2 === 0 }"
                >
                  <td>
                    {{ response.api_transaction_record.account_number }}
                  </td>
                  <td>
                    {{ response.tenant ? response.tenant.company : '' }}
                  </td>
                  <td>
                    {{ response.sales_rep ? response.sales_rep.name : 'House' }}
                  </td>
                  <td>{{ response.api_transaction_record.job_count }}</td>
                  <td>
                    {{
                      getDisplayTransactionMonth(
                        response.api_transaction_record.trans_yyyymm
                      ) | date: 'MMMM, yyyy'
                    }}
                  </td>
                  <td>
                    {{
                      response.api_transaction_record.invoice_amount
                        | currency: 'USD'
                    }}
                  </td>
                </div>
                @if (response.error) {
                  <div
                    class="table-row"
                    [ngClass]="{ 'bg-base-200': i % 2 === 0 }"
                  >
                    <td colspan="6" class="pt-0 text-error">
                      {{ response.error }}
                    </td>
                  </div>
                }
              }
            </tbody>
          </table>
        </div>
      </div>
    </ng-template>

    @if (apiFileValidationResponse) {
      <div class="mt-4 flex flex-col space-y-4">
        @if (errorValidationResponses.length > 0) {
          <ng-container
            [ngTemplateOutlet]="validationResponses"
            [ngTemplateOutletContext]="{
              responses: errorValidationResponses,
              title: 'Records with errors',
            }"
          ></ng-container>
        }
        @if (ignoredValidationResponses.length > 0) {
          <ng-container
            [ngTemplateOutlet]="validationResponses"
            [ngTemplateOutletContext]="{
              responses: ignoredValidationResponses,
              title: 'Records ignored',
            }"
          ></ng-container>
        }
        @if (zeroCostValidationResponses.length > 0) {
          <ng-container
            [ngTemplateOutlet]="validationResponses"
            [ngTemplateOutletContext]="{
              responses: zeroCostValidationResponses,
              title: 'Records with zero cost (no invoice to create)',
            }"
          ></ng-container>
        }
        @if (validValidationResponses.length > 0) {
          <ng-container
            [ngTemplateOutlet]="validationResponses"
            [ngTemplateOutletContext]="{
              responses: validValidationResponses,
              title: 'Records to create invoices for',
            }"
          ></ng-container>
        }
      </div>

      @if (
        errorValidationResponses.length === 0 &&
        validValidationResponses.length > 0
      ) {
        <div class="mt-4 text-center">
          <button
            class="btn btn-primary"
            (click)="uploadNewInvoices()"
            [disabled]="
              uploadingApiInvoices ||
              !apiTransactionsFile ||
              validatingApiTransactionsFile
            "
          >
            Upload Invoices
          </button>
        </div>
        @if (uploadingApiInvoices) {
          <div class="mt-4 flex justify-center">
            <div class="loading loading-spinner"></div>
          </div>
        }
        @if (errorUploadingApiInvoices) {
          <p class="mt-4 text-center text-error">
            {{ errorUploadingApiInvoices }}
          </p>
        }
      }
    }
  </div>
</dialog>

<dialog class="modal" #uploadJobLogsDialog>
  <div class="modal-box max-w-3xl p-8">
    <form method="dialog">
      <button
        class="btn btn-circle btn-ghost btn-sm absolute right-2 top-2"
        (click)="closeUploadJobLogsDialog()"
      >
        ✕
      </button>
    </form>

    <h3 class="text-lg font-bold">Upload API Job Logs</h3>

    <div class="mt-4">
      <label class="form-control w-full">
        <div class="label">
          <span class="label-text">Select Job Log Files</span>
          <span class="label-text-alt"
            >Files must be named: 10-digit-account-number.log (e.g.,
            7712345601.log)</span
          >
        </div>
        <input
          #jobLogsFileInput
          type="file"
          class="file-input file-input-bordered w-full"
          (change)="handleJobLogsFileChange($event)"
          multiple
          accept=".log"
        />
      </label>
    </div>

    @if (
      selectedJobLogFiles &&
      selectedJobLogFiles.length > 0 &&
      !uploadJobLogsResult
    ) {
      <div class="mt-4">
        <p class="mb-2 font-semibold">Selected Files:</p>
        <ul class="list-inside list-disc space-y-1">
          @for (file of selectedJobLogFiles; track file.name) {
            <li
              [ngClass]="{
                'text-error': !isValidJobLogFileName(file.name),
                'text-success': isValidJobLogFileName(file.name),
              }"
            >
              {{ file.name }}
              @if (!isValidJobLogFileName(file.name)) {
                <span class="text-xs text-error"
                  >(Invalid filename format)</span
                >
              }
            </li>
          }
        </ul>
      </div>
    }

    @if (uploadJobLogsResult) {
      <div class="mt-4">
        <div class="card card-bordered card-compact bg-base-100">
          <div class="card-body">
            <p class="card-title">Upload Results:</p>
            <div class="overflow-x-auto">
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th>Filename</th>
                    <th>Status</th>
                    <th>Logs Processed</th>
                  </tr>
                </thead>
                <tbody>
                  @for (
                    fileResult of uploadJobLogsResult.files;
                    let i = $index;
                    track fileResult.filename
                  ) {
                    <tr [ngClass]="{ 'bg-base-200': i % 2 === 0 }">
                      <td class="font-mono text-xs">
                        {{ fileResult.filename }}
                      </td>
                      <td>
                        @if (fileResult.success) {
                          <span class="badge badge-success">Success</span>
                        } @else {
                          <span class="badge badge-error">Failed</span>
                        }
                      </td>
                      <td>{{ fileResult.job_count }}</td>
                    </tr>
                    @if (fileResult.error) {
                      <tr [ngClass]="{ 'bg-base-200': i % 2 === 0 }">
                        <td colspan="3" class="pt-0 text-error">
                          {{ fileResult.error }}
                        </td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
            </div>
            <div class="mt-2 text-sm">
              @if (allFilesSuccessful()) {
                <p class="text-success">
                  All {{ getTotalFileCount() }} file(s) uploaded successfully
                </p>
              } @else {
                <p class="text-warning">
                  {{ getSuccessfulFileCount() }} of {{ getTotalFileCount() }}
                  file(s) uploaded successfully
                </p>
              }
            </div>
          </div>
        </div>
      </div>
    }

    <div class="mt-4 flex justify-end space-x-2">
      <button
        class="btn btn-primary"
        (click)="uploadJobLogs()"
        [disabled]="
          uploadingJobLogs ||
          !selectedJobLogFiles ||
          selectedJobLogFiles.length === 0 ||
          hasInvalidJobLogFiles
        "
      >
        @if (uploadingJobLogs) {
          <span class="loading loading-spinner loading-sm"></span>
        }
        Upload Job Logs
      </button>
    </div>

    @if (errorUploadingJobLogs) {
      <p class="mt-4 text-center text-error">
        {{ errorUploadingJobLogs }}
      </p>
    }
  </div>
</dialog>
